// getOrderData.js
'use strict';
import { Collection } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

/**
 * Select order data by data key
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} orderId - order id.
 * @param {string} dataKey - select data key.
 * @param {string} [sourceJointId] - source 'jointId' when using 'source' as data key.
 * @return {any} The selected order data.
 */
const getOrderData = createCachedSelector(
  (state, orderId) => state.getIn(['orders', orderId]),
  (state, orderId, dataKey) => dataKey,
  (state, orderId, dataKey, sourceJointId) => sourceJointId,
  (order, dataKey, sourceJointId) => {
    let result = undefined;
    if (order) {
      result = order.get(dataKey);
      if ('source' === dataKey) {
        result = order
          .get('sources')
          ?.find?.(s => sourceJointId === s.get('jointId'));
      } else if ('hasBoundCard' === dataKey) {
        result = !!order
          .get('sources')
          ?.find(source => !!source.getIn(['context', 'last4']));
      } else if ('sourcesByType' === dataKey) {
        result = order.get('sources').groupBy(source => source.get('type'));
      } else if ('currency' === dataKey) {
        result = order.get('currency')?.toUpperCase();
      }
    }
    return result instanceof Collection ? result.toJS() : result;
  }
)(
  (state, orderId, dataKey, sourceJointId) =>
    `${orderId}:${dataKey}:${sourceJointId}`
);

export default getOrderData;
